import { render, staticRenderFns } from "./EditorOption.vue?vue&type=template&id=527d8f5a&"
import script from "./EditorOption.vue?vue&type=script&lang=ts&"
export * from "./EditorOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports